import * as angular from "angular";
import {IController, IScope, IWindowService} from "angular";
import * as _ from "lodash";
import {BillingOrderService} from "../../services/billing-order.service";
import {ConsolidatedBillingOrderService} from "../../services/consolidated-billing-order.service";
import {BillingAccountDialogService} from "../../services/billing-account-dialog-service.service";
import {
  ExportConsolidatedBillingOrderTranslationsPayloadModel
} from "../../models/export-consolidated-billing-order-translations-payload.model";
import {
  ConsolidatedBillingOrderAddBillingOrdersPayloadModel
} from "../../models/consolidated-billing-order-add-billing-orders-payload.model";
import {SapDocumentType} from "../../types/sap-document.type";
import {ConsolidatedBillingOrderStatusType} from "../../types/consolidated-billing-order-status.type";
import {SplitService} from "../../../commons/services/split-service.service";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {OmsService} from "../../../oms/services/oms-service.service";
import {OmsDialogService} from "../../../oms/services/oms-dialog-service.service";
import {ConsolidatedBillingOrderDialogService} from "../../services/consolidated-billing-order-dialog.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class ConsolidatedBillingOrderViewCtrl implements IController {

  consolidatedBillingOrder: any;
  onBack: Function;

  private originalConsolidatedBillingOrder: any;
  public billingOrderIds: string[];
  public selectedBillingOrders: any = [];
  public selectedOrder: any;
  public isEditPriceMode: boolean;
  public consolidatedBillingOrderStatusType: typeof ConsolidatedBillingOrderStatusType = ConsolidatedBillingOrderStatusType;
  public canCreateInvoice: boolean;
  public totalRefundAmount: number;
  public tableSettings: any;
  public queryString: string;
  public doReload: boolean = false;


  constructor(private $state, private splitService: SplitService, private bringozLoaderService: BringozLoaderService, private $scope: IScope, private $translate,
              private $billingAccounts, private filePrinter, private $consolidatedBillingOrders, private billingOrderService: BillingOrderService, public $window: IWindowService,
              private omsService: OmsService, private omsDialogService: OmsDialogService, private consolidatedBillingOrderService: ConsolidatedBillingOrderService,
              private billingAccountDialogService: BillingAccountDialogService, private consolidatedBillingOrderDialogService: ConsolidatedBillingOrderDialogService,
              private confirmDialogService: ConfirmDialogService) {
    this.tableSettings = this.splitService.getSiteBillingOrdersSettings();
  }




  $onInit() {
    this.originalConsolidatedBillingOrder = angular.copy(this.consolidatedBillingOrder);



    const consolidatedBillingOrderRef = this.$consolidatedBillingOrders(this.consolidatedBillingOrder.id);
    this._setBillingOrders();
    this._setConsolidatedBillingOrder(this.consolidatedBillingOrder);

    consolidatedBillingOrderRef.$bindCtrl(this.$scope, this, 'consolidatedBillingOrder');
    consolidatedBillingOrderRef.$registerOnUpdateHandler(this, (consolidatedBillingOrder) => {
      this._setConsolidatedBillingOrder(consolidatedBillingOrder);

      if (this.originalConsolidatedBillingOrder.billingOrderReferences?.length !== consolidatedBillingOrder.billingOrderReferences?.length) {
        this._setBillingOrders();
      }
      this.originalConsolidatedBillingOrder = consolidatedBillingOrder;
    })
  }

  onQueryChange(queryString) {
    this.queryString = queryString;
  }

  onViewSettingsChange(settings) {
    this.tableSettings = settings;
    this.splitService.setSiteBillingOrdersSettings(settings);
  }

  onEditConsolidatedBillingOrder() {
    this.billingAccountDialogService.editConsolidatedBillingOrder(this.consolidatedBillingOrder)
      .then((payload) => {
        this._updateConsolidatedBillingOrder(this.consolidatedBillingOrder.id, payload.name, payload.docDate, payload.comment, payload.billTo);
      })
  }

  onEditOmsOrder(orderId, orderStatus) {
    if (orderStatus !== 'Completed') {
      const url = this.$state.href('order.edit', {id: orderId});
      this.$window.open(url, '_blank', 'width=900,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no')
    } else {
      this.omsService.getOne(orderId)
        .then(omsOrder => {
          this._editCompletedOmsOrder(omsOrder);
        })
    }
  }

  onCreateInvoice() {
    this.billingAccountDialogService.selectSapDocumentType()
      .then((sapDocumentType: SapDocumentType) => {
        this.consolidatedBillingOrderService.createInvoice(this.consolidatedBillingOrder.id, sapDocumentType);
      })
  }

  onCreateRefund() {
    this.billingAccountDialogService.refundConsolidatedBillingOrder(this.consolidatedBillingOrder)
      .then((payload) => {
        this._refundConsolidatedBillingOrder(this.consolidatedBillingOrder.id, payload.refundAmount, payload.comment, payload.dueDate);
      })
  }

  onAddBillingOrders() {
    this.billingAccountDialogService.addBillingOrdersToConsolidatedOrder(this.consolidatedBillingOrder.billingAccountId)
      .then((billingOrdersIdsToAdd) => {
        this._addBillingOrders(billingOrdersIdsToAdd);
      })
  }

  onExportPDF(event) {
    this.billingAccountDialogService.selectPdfTemplate(event, true)
      .then((payload: {pdfTemplate, includeEmptyPrices}) => {
        this._exportPDF(payload.pdfTemplate, payload.includeEmptyPrices);
      })
  }

  onExportCSV(includeEmptyPrices, event) {
    const zoneId = this.splitService.getTimeZone();
    const payload: ExportConsolidatedBillingOrderTranslationsPayloadModel = this._getExportPayload();
    this.consolidatedBillingOrderService.exportCSV(this.consolidatedBillingOrder.id, payload, includeEmptyPrices, zoneId);
  }

  payManually(event) {
    this.consolidatedBillingOrderDialogService.payManually(this.consolidatedBillingOrder, event)
      .then((invoiceId: string) => {
        const payload = {
          invoiceId: invoiceId
        }
        this.consolidatedBillingOrderService.payManually(this.consolidatedBillingOrder.id, payload);
      })
  }

  resetPayManually(event) {
    this.confirmDialogService.confirm('Reset pay manually', 'Are you sure you want to reset the proforma?', event)
      .then(() => {
        this.consolidatedBillingOrderService.resetPayManually({proformaId: this.consolidatedBillingOrder.id});
      })
  }

  onPrint(event) {
    this.billingAccountDialogService.selectPdfTemplate(event, true)
      .then((payload: {pdfTemplate, includeEmptyPrices}) => {
        this._print(payload.pdfTemplate, payload.includeEmptyPrices);
      })
  }

  onDelete(event) {
    this.consolidatedBillingOrderService.removeBillingOrders(this.consolidatedBillingOrder.id, [], [], true)
      .then(() => {
        this.onBack();
      });
  }

  onRemoveBillingOrder(billingOrder) {
    this._removeBillingOrders([billingOrder]);
  }

  onRemoveBillingOrders(billingOrders) {
    this._removeBillingOrders(billingOrders);
  }


  onClearSelectedBillingOrders() {
    this.selectedBillingOrders = [];
  }


  onOpenActions($mdMenu) {
    this.canCreateInvoice = !_.filter(this.consolidatedBillingOrder.billingOrderReferences || [], (c) => {
      return c.status !== this.consolidatedBillingOrderStatusType.Delivered;
    }).length
    $mdMenu.open();
  }

  onSelectedBillingOrdersChange(billingOrders) {
    this.selectedBillingOrders = billingOrders;
  }

  onSelectOrder(billingOrder) {
    this.onSetEditPricingMode(false);
    this.selectedOrder = _.isEqual(billingOrder.id, _.get(this.selectedOrder, 'id')) ?
      undefined : angular.copy(billingOrder);
  }

  onTogglePricingMode(billingOrder) {
    if (!this.selectedOrder) {
      this.selectedOrder = billingOrder;
      this.onSetEditPricingMode(true);
    } else {
      this.onSetEditPricingMode(!this.isEditPriceMode);
    }
  }

  onEditBillingOrder(billingOrder) {
    this.selectedOrder = billingOrder;
    this.onSetEditPricingMode(true);
  }

  onSetEditPricingMode(isEdit) {
    this.isEditPriceMode = isEdit;
  }

  onReloadBillingOrders() {
    this.doReload = false;
  }

  // onCreateInvoice(billingOrder, $event) {
  //   this.bringozLoaderService.on();
  //   this.$billingAccounts(billingOrder.accountReference.billingAccountId).$asyncValue()
  //     .then((billingAccount) => {
  //       this._openCreateInvoiceDialog([billingOrder.id], $event, billingAccount);
  //     })
  //     .finally(() => {
  //       this.bringozLoaderService.off();
  //     })
  // }

  // onDeleteInvoice(billingOrder, $event) {
  //   this.BillingAccountDialogService.deleteInvoice($event, billingOrder)
  //     .then(() => {
  //       this._deleteInvoice(billingOrder.id);
  //     })
  // }

  private _getConsolidatedBillingOrder() {
    this.consolidatedBillingOrderService.getOne(this.consolidatedBillingOrder.id)
      .then((updatedConsolidatedBillingOrder) => {
        this._setConsolidatedBillingOrder(updatedConsolidatedBillingOrder);
      })
  }

  private _setBillingOrders() {
    this.onClearSelectedBillingOrders();
    this.billingOrderIds = _.map(this.consolidatedBillingOrder.billingOrderReferences, 'id');
  }

  private _addBillingOrders(billingOrdersIds) {
    const payload: ConsolidatedBillingOrderAddBillingOrdersPayloadModel = {
      addBillingOrderIds: billingOrdersIds,
      billingAccountId: this.consolidatedBillingOrder.billingAccountId
    }
    this.consolidatedBillingOrderService.addBillingOrders(this.consolidatedBillingOrder.id, payload)
      .then(() => {
        // this._setBillingOrders();
      })
  }

  private _removeBillingOrders(selectedBillingOrders) {
    this.consolidatedBillingOrderService.removeBillingOrders(this.consolidatedBillingOrder.id, _.map(selectedBillingOrders, 'id'))
      .then(() => {
        this.doReload = true;
        // this._setBillingOrders();
        this._getConsolidatedBillingOrder();
      });
  }

  private _editCompletedOmsOrder(omsOrder) {
    const orderCopy = angular.copy(omsOrder);
    this.omsDialogService.editCompletedOrder(orderCopy)
      .then((updatedOrder) => {
        this._updateCompletedOrder(updatedOrder);
      })
  }

  private _updateCompletedOrder(order) {
    this.omsService.updateCompletedOrder(order.id, order);
  }


  private _openCreateInvoiceDialog(billingOrderIds, $event, billingAccount) {
    this.billingAccountDialogService.createInvoice($event, billingOrderIds, billingAccount)
      .then((invoicePayload) => {
        invoicePayload.billingAccountId = billingAccount.id;
        this._createInvoice(invoicePayload);
      })
  }

  private _createInvoice(invoicePayload, isConsolidateInvoice?) {
    if (!!isConsolidateInvoice) {
      invoicePayload.isConsolidateInvoice = true;
    }
    this.billingOrderService.createInvoice(invoicePayload)
      .then(() => {
      })
  }

  private _deleteInvoice(billingOrderId) {
    this.billingOrderService.deleteInvoice(billingOrderId)
      .then((res) => {
        this.selectedOrder = angular.copy(res);
      })
  }

  private _updateConsolidatedBillingOrder(consolidatedId, name, docDate, comment, billTo) {
    this.consolidatedBillingOrderService.update(consolidatedId, name, docDate, comment, billTo)
      .then((updatedConsolidatedBillingOrder) => {
        this._setConsolidatedBillingOrder(updatedConsolidatedBillingOrder);
        this._setBillingOrders();
      })
  }

  private _refundConsolidatedBillingOrder(consolidatedId, refundAmount, comment, dueDate) {
    this.consolidatedBillingOrderService.refund(consolidatedId, refundAmount, comment, dueDate);
  }

  private _setConsolidatedBillingOrder(updatedConsolidatedBillingOrder) {
    this.consolidatedBillingOrder = updatedConsolidatedBillingOrder;
    this.totalRefundAmount = _.reduce(updatedConsolidatedBillingOrder.refundInfos, (sum: any, refundData) => {
      return sum + (refundData?.refundAmount || 0);
    }, 0);
  }



  private _exportPDF(proformaPdfTemplate, includeEmptyPrices?) {
    const zoneId = this.splitService.getTimeZone();
    const payload = {
      zoneId: zoneId,
      proformaPdfTemplate: proformaPdfTemplate,
      includeEmptyPrices: includeEmptyPrices,
      ids: [this.consolidatedBillingOrder.id]
    }

    this.consolidatedBillingOrderService.exportPDF(payload);
  }

  private _print(proformaPdfTemplate, includeEmptyPrices?: boolean) {
    const zoneId = this.splitService.getTimeZone();
    this.consolidatedBillingOrderService.getPDF(this.consolidatedBillingOrder.id, proformaPdfTemplate, includeEmptyPrices, zoneId)
      .then((res) => {
        if (res.data) {
          let fileName = res.headers('content-disposition').split('filename = ')[1];
          this.filePrinter(res.data, fileName, _.get(res.headers(), "content-type"))
        }
      })
  }

  private _getExportPayload(): ExportConsolidatedBillingOrderTranslationsPayloadModel {
    return {
      createdAt: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDER_COLUMNS.createdAt'),
      completedAt: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDER_COLUMNS.completedAt'),
      orderId: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDER_COLUMNS.orderId'),
      origin: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDER_COLUMNS.origin'),
      destination: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDER_COLUMNS.destination'),
      packageName: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDER_COLUMNS.packageName'),
      barcode: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDER_COLUMNS.barcode'),
      referenceIds: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDER_COLUMNS.referenceIds'),
      quantity: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDER_COLUMNS.quantity'),
      packagePrice: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDER_COLUMNS.packagePrice'),
      price: this.$translate.instant('EXPORT_CONSOLIDATED_BILLING_ORDER_COLUMNS.price')
    }
  }

}

angular
  .module('bringoz.admin.billing-accounts')
  .component('consolidatedBillingOrderView', {
    bindings: {
      consolidatedBillingOrder: '<',
      onBack: '&'
    },
    template: require('./consolidated-billing-order-view.html').default,
    controller: ConsolidatedBillingOrderViewCtrl
  });
